import React from 'react';

import SectionMessage from '@atlaskit/section-message';
import { useSession } from 'src/services/session';

import { textifyError } from 'src/lib/error';

import JiraSideAdminLink from 'src/views/components/links/JiraSideAdminLink';
import LoginLink from 'src/views/components/links/LoginLink';

function appendDot(str) {
  if (str && typeof str === 'string' && str[str.length - 1] !== '.') str = `${str}.`;
  return str;
}

const LinkedIncidentErrorMessage = ({ linkedIncident }) => {
  const { loggedIn } = useSession();
  const { bySidebarInfo } = linkedIncident;

  const SidebarInfoError = () => Boolean(bySidebarInfo.error) && (
    <div>
      <span>{appendDot(textifyError(bySidebarInfo.error))} </span>
      <span>Please check if Token is valid on the <JiraSideAdminLink>configuration page</JiraSideAdminLink></span>
    </div>
  );

  const apiAccessError = linkedIncident.error === bySidebarInfo.error ? null : linkedIncident.error;
  const PublicApiAccessError = () => Boolean(apiAccessError) && (
    <div>
      <br/>
      <span>{appendDot(textifyError(apiAccessError))} </span>
      {!loggedIn && <span>Please check if REST API Token is valid on the <JiraSideAdminLink>configuration page</JiraSideAdminLink> or <LoginLink>login</LoginLink></span>}
    </div>
  );

  return (
    <div>
      <SectionMessage appearance="error" title="Can not load incident">
        <SidebarInfoError/>
        <PublicApiAccessError/>
      </SectionMessage>
    </div>
  );
};

export default LinkedIncidentErrorMessage;
